import ApiService from '@/core/services/api.service';

// Cache chia sẻ ở cấp module: nhiều component/instance (vd nhiều dòng BillItem trên 1 bill)
// chỉ gọi GET feature-flags/get-active MỘT lần mỗi phiên thay vì mỗi instance gọi 1 lần.
let activeFeatureFlagsPromise = null;

const loadActiveFeatureFlags = () => {
  if (!activeFeatureFlagsPromise) {
    activeFeatureFlagsPromise = ApiService.get('feature-flags/get-active')
      .then(({ data }) => data.data || [])
      .catch(() => {
        // Lỗi request: reset để lần sau còn thử lại, tạm coi như không có flag nào bật.
        activeFeatureFlagsPromise = null;
        return [];
      });
  }
  return activeFeatureFlagsPromise;
};

const featureFlagMixin = {
  data() {
    return {
      featureFlags: [],
    };
  },
  created() {
    this.fetchActiveFeatureFlags();
  },
  methods: {
    fetchActiveFeatureFlags() {
      loadActiveFeatureFlags().then((flags) => {
        this.featureFlags = flags;
      });
    },
    isFeatureActive(featureFlagName) {
      return this.featureFlags.some(
        (featureFlag) => featureFlag === featureFlagName,
      );
    },
  },
};
export default featureFlagMixin;
